export const getErrorLogIdFromResponse = (response: any) => {
    let errorLogId = response.toString().substring(0, response.toString().indexOf("-"));
    errorLogId = errorLogId.replace("Error: System.Exception: ", "");
    return errorLogId;
}